import { useState, useEffect } from "react";
import "../style/experiance.css"; 

export default function Timeline() {
  const [activeTab, setActiveTab] = useState("Experiance");
  const [animationClass, setAnimationClass] = useState("slide-in-right");
  const [selectedItem, setSelectedItem] = useState(null); 
  const [showPopup, setShowPopup] = useState(false); 

  const experience = [
    {
      id: 1,
      title: "Software Engineer",
      company: "TUVOC Technologies Pvt Ltd.",
      date: "May 2025 – Present",
      description: "Build and maintain scalable web applications using React.js, Node.js, Express.js, MySQL, and MongoDB across the full stack. Design and integrate RESTful APIs connecting front-end interfaces with backend services and databases. Optimize SQL and MongoDB queries to improve application performance and reduce response times.",
      side: "left",
    },
    {
      id: 2,
      title: "Software Engineer Intern",
      company: "TUVOC Technologies Pvt Ltd.",
      date: "September 2024 – April 2025",
      description: "Contributed to core feature development for production MERN stack applications, working closely with senior engineers. Assisted in building and testing RESTful API integrations and responsive UI components.",
      side: "right",
    },
    {
      id: 3,
      title: "Front-End Developer",
      company: "Under Graduate Student Fellowship, CHARUSAT",
      date: "November 2023 – March 2024",
      description: "Redesigned key UI components with the fellowship team, improving visual consistency and cross-browser compatibility.",
      side: "left",
    },
    {
      id: 4,
      title: "Full Stack Developer Intern",
      company: "Internauts Infotech",
      date: "May 2023 – June 2023",
      description: "Engineered and launched a dynamic web platform by converting detailed design mockups into functional React.js and Express.js components.",
      side: "right",
    },
  ];

  const education = [
    {
      id: 1,
      title: "Secondary Education (SSC)",
      company: "K.M.Patel Vidhyamandir",
      date: "June 2018 – May 2019",
      description: "Completed foundational education with a focus on subjects like science, mathematics",
      side: "left",
    },
    {
      id: 2,
      title: "Higher Secondary Education (HSC)",
      company: "K.M.Patel Vidhyamandir",
      date: "June 2020 – May 2021",
      description: "Specialized in Mathematics, gaining a strong understanding of programming, computer science, and applied IT concepts.",
      side: "right",
    },
    {
      id: 3,
      title: "B.Tech in Information Technology",
      company: "Charotar University of Science and Technology",
      date: "June 2021 – May 2025",
      description: "Completed a Bachelor's degree in Information Technology with a CGPA of 8.66. Coursework covered computer science, software engineering, database management, web development, and emerging technologies including cloud computing and AI.",
      side: "left",
    }
  ];

  const achievement = [
    {
      id: 1,
      title: "Finalist, Azadi ka Amrit Mahotsav Hackathon 2022",
      company: "Ganpat University",
      date: "2022",
      description: "Reached the finals after developing a user-friendly complaint registration website for the District Development Office (DDO) Patan, enabling citizens to register complaints and track their status.",
      side: "left",
    },
    {
      id: 2,
      title: "Top Ranker, PU CODE Hackathon 2024",
      company: "Parul University",
      date: "2024",
      description: "Recognized as a top ranker at PU CODE Hackathon 2024 for building a MERN stack platform to host coding contests and aggregate coding profile summaries.",
      side: "right",
    },
    {
      id: 3,
      title: "NPTEL Certified: DBMS, OS, C and C++",
      company: "NPTEL",
      date: "June 2021 – May 2024",
      description: "NPTEL certified in Database Management System, Operating System, and Programming in C and C++.",
      side: "left",
    }
  ];

  const displayData =
    activeTab === "Experiance"
      ? experience
      : activeTab === "Education"
      ? education
      : achievement;

  useEffect(() => {
    setAnimationClass("slide-out-left");
    const timer = setTimeout(() => {
      setAnimationClass("slide-in-right");
    }, 300); 

    return () => clearTimeout(timer);
  }, [activeTab]);
  const handleReadMore = (item) => {
    setSelectedItem(item); 
    setShowPopup(true); 
  };

  const handleClosePopup = () => {
    setShowPopup(false); 
    setSelectedItem(null); 
  };

  return (
    <div className="main-experiance">
      <div className="background-image"></div>
      <div className="experiance_container">
        {/* Tabs */}
        <div className="tabs" data-aos="fade-down" data-aos-duration="800">
          {["Experiance", "Education", "Achievement"].map((tab) => (
            <button
              key={tab}
              className={activeTab === tab ? "active" : ""}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="timeline">
          <div className="line"></div>
          {displayData.map((item, index) => (
            <div key={index} className={`event ${item.side}`}>
              <div
                className="card"
                data-aos="zoom-in-up"
                data-aos-duration="800"
              >
                <div className={`fade-content ${animationClass}`}>
                  <h3>{item.title}</h3>
                  <p>{item.company}</p>
                  <p>{item.date}</p>
                </div>
                <button onClick={() => handleReadMore(item)}>Read More</button>
              </div>
            </div>
          ))}
        </div>
      </div>

{showPopup && selectedItem && (
  <div
    className={`timeline-popup-overlay ${showPopup ? "show" : ""}`}
    onClick={handleClosePopup}
  >
    <div className="timeline-popup" onClick={(e) => e.stopPropagation()}>
      <button className="close-timeline-popup" onClick={handleClosePopup}>
        ×
      </button>
      <div className="timeline-popup-content">
        <h2>{selectedItem.title}</h2>
        <p>{selectedItem.company}</p>
        <p>{selectedItem.date}</p>
        <p>{selectedItem.description}</p>
      </div>
    </div>
  </div>
)}
    </div>
  );
}
